import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "relationSection"]

  connect() {
    this.toggleRelations()
  }

  toggleRelations() {
    const value = this.selectTarget.value
    const shouldShow = value === "married"
    this.relationSectionTarget.style.display = shouldShow ? "block" : "none"
  }
}
